import { render, staticRenderFns } from "./UpdateNumdoc.vue?vue&type=template&id=9b06b9de&scoped=true"
import script from "./UpdateNumdoc.vue?vue&type=script&lang=js"
export * from "./UpdateNumdoc.vue?vue&type=script&lang=js"
import style0 from "./UpdateNumdoc.vue?vue&type=style&index=0&id=9b06b9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b06b9de",
  null
  
)

export default component.exports